import { CommonModule } from '@angular/common';
import {Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit, signal, inject} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import { Router } from '@angular/router';
type AntragElement = HTMLElement & {
  showHeader: boolean;
  showLogin: boolean;
  username: string;
  password: string;
};
@Component({
  selector: 'app-antrag',
  standalone: true,
  imports: [
    MatIcon,
    CommonModule
  ],
  templateUrl: './antrag.component.html',
  styleUrl: './antrag.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AntragComponent implements OnInit, OnDestroy {
  readonly ready = signal(false);
  private readonly router = inject(Router);

  private readonly onAntragsnummerChange = (event: Event) => {
    const customEvent = event as CustomEvent<string>;
    const action = (customEvent.detail ?? '').toLowerCase();
    console.log('geklickte Antrag:', action);

    if (action) {
      void this.router.navigate(['/vgv'], {
        queryParams: { id: action }
      });
    }
  };

  private readonly neuerAntragChange = (event: Event) => {
    const customEvent = event as CustomEvent<string>;
    const action = (customEvent.detail ?? '').toLowerCase();

    console.log('geklickte Antrag:', action);

    if (action === 'vgv') {
      void this.router.navigate(['/vgv']);
    }
  };

  ngOnInit(): void {
    customElements.whenDefined('antrgsuebersicht-app').then(() => {
      this.ready.set(true);

      setTimeout(() => {
        const el = document.querySelector('antrgsuebersicht-app') as AntragElement | null;

        if (!el) {
          return;
        }

        el.showHeader = false;
        el.showLogin = false;
        el.username = 'robert';
        el.password = 'test';

        el.addEventListener(
          'antragsnummerChange',
          this.onAntragsnummerChange as EventListener
        );
        el.addEventListener(
          'neuerAntrag',
          this.neuerAntragChange as EventListener
        );
      }, 0);
    });
  }

  ngOnDestroy(): void {
    const el = document.querySelector('antrgsuebersicht-app') as AntragElement | null;

    if (el) {
      el.removeEventListener(
        'antragsnummerChange',
        this.onAntragsnummerChange as EventListener
      );
    }
  }

  isIsselhorsterReady(): boolean {
    return this.ready();
  }
}
